import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Sentence-case helper: capitalises ONLY the first letter of the first word,
// lowercases everything else, and preserves brand-style codes (tokens that
// contain a digit such as "H 360", "EM-200", "H560").
// Per user request 28-May-2026: "first letter capital rest small".
//   "CLINICAL CHEMISTRY"       → "Clinical chemistry"
//   "ERBA ELITE H CLEAN"       → "Erba elite h clean"
//   "H560 REAGENT PACK"        → "H560 reagent pack"
//   "H 360"                    → "H 360" (preserved)
// Function name retained for backwards-compatibility with existing imports.
export function toTitleCase(value) {
  if (value === null || value === undefined) return "";
  const s = String(value).trim();
  if (!s) return "";
  // Known acronyms must always render fully upper-cased (e.g. "ESR").
  const ACRONYMS = new Set(["ESR"]);
  if (ACRONYMS.has(s.toUpperCase())) return s.toUpperCase();
  // Already mixed-case text is treated as intentionally/officially cased
  // (e.g. brand names "Liquixx Albumin", "ErbaQik Sickle Cell (A,S,C)",
  // abbreviations like "OCPC") — preserve it verbatim. Only ALL-CAPS or
  // all-lowercase ERP strings get normalised below.
  if (/[A-Z]/.test(s) && /[a-z]/.test(s)) return s;
  const tokens = s.split(/\s+/).map(part => {
    // Tokens containing digits are brand/product codes — keep verbatim.
    if (/[0-9]/.test(part)) return part;
    return part.toLowerCase();
  });
  // Capitalise the first alphabetic (non-code) token only.
  for (let i = 0; i < tokens.length; i++) {
    const t = tokens[i];
    if (!/[0-9]/.test(t) && t.length > 0) {
      tokens[i] = t.charAt(0).toUpperCase() + t.slice(1);
      break;
    }
  }
  return tokens.join(" ");
}

// Alias for callers that want explicit naming.
export const toSentenceCase = toTitleCase;
